import lottie from 'lottie-web';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  async preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
    await loadFonts();
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.audioLoad();
    this.gameAssetsLoad();

    this.load.start();

    this.load.on(
      'progress',
      function () {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      function () {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  audioLoad() {
    this.load.audio('bgMusic', 'assets/G1 & G2 Game Sounds/gameBGSound.mp3');
  }

  gameAssetsLoad() {
    // StartScene assets
    this.load.image('BG', 'assets/StartScene/BG.png');
    this.load.image('cycleBlur', 'assets/StartScene/cycleBlur.png');
    this.load.image('play', 'assets/StartScene/play.png');
    this.load.image('title', 'assets/StartScene/title.png');
    this.load.image('playBlack', 'assets/StartScene/playBlack.png');

    // GetCoinScene assets
    this.load.image('BG2', 'assets/GetCoinScene/BG2.png');
    this.load.image('coin', 'assets/GetCoinScene/coin.png');
    this.load.image('coinBlack', 'assets/GetCoinScene/coinBlack.png');
    this.load.image('cycle', 'assets/GetCoinScene/cycle.png');
    this.load.multiatlas(
      'walkIn',
      'assets/Character Anims/characterWalkAnim.json',
      'assets/Character Anims',
    );

    // GameScene assets
    this.load.image('BG3', 'assets/GameScene/BG3.png');
    this.load.image('almirah', 'assets/GameScene/almirah.png');
    this.load.image('backLock', 'assets/GameScene/backLock.png');
    this.load.image('locker1', 'assets/GameScene/newLocker1.png');
    this.load.image('locker2', 'assets/GameScene/newLocker2.png');
    this.load.image('bolt', 'assets/GameScene/bolt.png');

    this.load.image('wheel', 'assets/GameScene/wheel.png');
    this.load.image('wheelGreen1', 'assets/GameScene/wheel1.png');
    this.load.image('wheelGreen2', 'assets/GameScene/wheel2.png');
    this.load.image('wheelGreen3', 'assets/GameScene/wheel3.png');

    this.load.image('bar', 'assets/GameScene/bar.png');
    this.load.image('reward', 'assets/GameScene/reward.png');
    this.load.image('bottom', 'assets/GameScene/bottom2.png');
    this.load.image('gold', 'assets/GameScene/gold.png');
    this.load.image('plus', 'assets/GameScene/plus.png');
    this.load.image('equal', 'assets/GameScene/equal.png');
    this.load.image('disabled', 'assets/GameScene/inputDisabled.png');
    this.load.image('default', 'assets/GameScene/inputDefault.png');
    this.load.image('typing', 'assets/GameScene/inputTyping.png');
    this.load.image('correct', 'assets/GameScene/inputCorrect.png');
    this.load.image('wrong', 'assets/GameScene/inputWrong.png');
    this.load.image('cursor', 'assets/GameScene/cursor.png');
    this.load.image('overlay', 'assets/GameScene/overlay.png');
    this.load.image('yay', 'assets/GameScene/yay.png');
    this.load.image('coins', 'assets/GameScene/coins.png');
    this.load.image('buy', 'assets/GameScene/buy.png');
    this.load.image('buyBlack', 'assets/GameScene/buyBlack.png');
    this.load.image('disabled2', 'assets/GameScene/inputDisabled2.png');
    this.load.image('default2', 'assets/GameScene/inputDefault2.png');
    this.load.image('typing2', 'assets/GameScene/inputTyping2.png');
    this.load.image('correct2', 'assets/GameScene/inputCorrect2.png');
    this.load.image('wrong2', 'assets/GameScene/inputWrong2.png');
  }

  update() {}
}
